import { render } from "./TrainingTrainingPeriodComponent.vue?vue&type=template&id=d7a35de8&scoped=true"
import script from "./TrainingTrainingPeriodComponent.vue?vue&type=script&lang=js"
export * from "./TrainingTrainingPeriodComponent.vue?vue&type=script&lang=js"

import "./TrainingTrainingPeriodComponent.vue?vue&type=style&index=0&id=d7a35de8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d7a35de8"]])

export default __exports__